import { NavLink } from "react-router-dom";
import { getUser } from "../lib/auth";
import { AccountMenu } from "./AccountMenu";
import { ChainSwitch } from "./ChainSwitch";
import { ThemeToggle } from "./ThemeToggle";
import { WalletChip } from "./WalletChip";

/**
 * Wordmark, Trade and Orders, theme toggle, account menu; anything occasional is
 * in the account menu. No link to the business portal: another product, another audience.
 */

/** Routed destination — the active one is emphasised, not merely underlined. */
function NavRoute({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      className={({ isActive }) =>
        isActive ? "topnav-link topnav-link-active" : "topnav-link"
      }
    >
      {label}
    </NavLink>
  );
}

export function TopBar() {
  const user = getUser();
  const isWallet = user?.kind === "wallet" && user.address !== undefined;

  return (
    <header className="topbar">
      <div className="topbar-left">
        {/* Not a link: the Trade item already owns "/". */}
        <span className="wordmark">aile</span>

        <nav className="topnav" aria-label="Main">
          <NavRoute to="/" label="Trade" />
          <NavRoute to="/orders" label="Orders" />
        </nav>
      </div>

      <div className="topbar-right">
        <ChainSwitch />
        <ThemeToggle />

        {/* Until a wallet connects there is no account to open a menu on. */}
        {isWallet ? <AccountMenu /> : <WalletChip />}
        {/* A demo session has no wallet, but still has a session to leave. */}
        {!isWallet && user !== null && <AccountMenu />}
      </div>
    </header>
  );
}
